export default apiFetch => async payload => {
  const { mode, topic, from, to, postType, page = 1 } = payload;

  const response = await apiFetch({
    endpoint: `posts?mode=${mode}&postType=${postType}&topic=${topic}&from=${from}&to=${to}&page=${page}`,
    method: "get"
  });

  return await response.json();
};
